module.exports = __webpack_public_path__ + "static/media/19.917cc1d9.jpg";